import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Countdown from 'components/Countdown';

const styles = (theme) => ({
  root: {
    margin: 0
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1)
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    textAlign: 'justify',
    textIndent: '10px',
    lineHeight: '20px'
  }
}))(MuiDialogContent);

const DialogCountdown = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    textAlign: 'end',
    textIndent: '10px',
    lineHeight: '20px'
  }
}))(MuiDialogContentText);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

export default function InformDialog({ informacao, onClose, titulo, countdown }) {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);

    onClose && onClose();
  };
  if(countdown){
    setTimeout(handleClose, countdown);
  }

  const tituloDialog = titulo ? titulo : "Informação"

  return (
    <div>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle onClose={handleClose}>{tituloDialog}</DialogTitle>
        <DialogContent dividers>
          {informacao}          
          {countdown ? (<DialogCountdown><Countdown initialMilliseconds={countdown} /></DialogCountdown>) : (<></>)}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Entendi
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
